import React from 'react';
import faker from 'faker';
import PropTypes from 'prop-types';
import { sentenceCase } from 'change-case';
import { toast } from 'react-hot-toast';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import { Icon } from '@iconify/react';
import { formatDistance } from 'date-fns';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Card, Typography, CardHeader, CardContent, Box, Button, Divider } from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot
} from '@mui/lab';
import _ from 'lodash';
// utils
import { fDateTime } from '../../../utils/formatTime';
// services
import * as myLayananService from '../../../services/mylayanan';

// ----------------------------------------------------------------------

const TIMELINES = [
  {
    title: '1983, orders, $4220',
    time: faker.date.past(),
    type: 'order1'
  },
  {
    title: '12 Invoices have been paid',
    time: faker.date.past(),
    type: 'order2'
  },
  {
    title: 'Order #37745 from September',
    time: faker.date.past(),
    type: 'order3'
  },
  {
    title: 'New order placed #XF-2356',
    time: faker.date.past(),
    type: 'order4'
  },
  {
    title: 'New order placed #XF-2346',
    time: faker.date.past(),
    type: 'order5'
  }
];

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool
};

function OrderItem({ item, isLast }) {
  const { attributes, type, createdAt, id } = item;
  return (
    <>
      {!_.isEmpty(item) && (
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot
              sx={{
                bgcolor:
                  (attributes.status === 'submitted' && 'primary.main') ||
                  (attributes.status === 'active' && 'success.main') ||
                  (attributes.status === 'deleted' && 'error.main') ||
                  (attributes.status === 'draft' && 'warning.main') ||
                  'error.main'
              }}
            />
            {isLast ? null : <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="subtitle2">{`${type && sentenceCase(type)} - ${
              attributes.status && sentenceCase(attributes.status)
            }`}</Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {fDateTime(createdAt)}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      )}
    </>
  );
}

AppOrderTimeline.propTypes = {
  user: PropTypes.object.isRequired
};

export default function AppOrderTimeline({ user }) {
  const [activites, setActivities] = React.useState([]);

  // -------- Get Activities

  const getActivities = async () => {
    try {
      const id = user?.attributes?.id_instansi;
      const role = user?.attributes?.role;
      const userID = user?.attributes?.id;

      if (!id) return;
      const body = { id_instansi: id, user_id: userID, role };

      const result = await myLayananService.getLayananActivities(body);

      if (result) setActivities(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getActivities();
  }, [user]);
  return (
    <Card
      sx={{
        '& .MuiTimelineItem-missingOppositeContent:before': {
          display: 'none'
        }
      }}
    >
      <CardHeader title="Aktivitas" />
      <CardContent>
        <>
          {!_.isEmpty(activites) && (
            <Timeline>
              {activites.map((item, index) => (
                <OrderItem key={index} item={item} isLast={index === item.length - 1} />
              ))}
            </Timeline>
          )}

          {_.isEmpty(activites) && <Typography variant="body1">Belum ada aktivitas</Typography>}
        </>
      </CardContent>
      {/* <Divider />

      <Box sx={{ p: 2, textAlign: 'right' }}>
        <Button
          to="#"
          size="small"
          color="inherit"
          component={RouterLink}
          endIcon={<Icon icon={arrowIosForwardFill} />}
        >
          View all
        </Button>
      </Box> */}
    </Card>
  );
}
